import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";
import { MealCard } from "@/components/meals/MealCard";
import { ListLoadingState } from "@/components/loading/ListLoadingState";
interface FavoriteMeal {
  meals: {
    id: string;
    name: string;
    chef: {
      first_name: string | null;
      last_name: string | null;
    } | null;
    price: number;
    image: string;
    rating: number;
    reviews_count: number;
    availability_slots: any[];
  };
}
const Favorites = () => {
  const [favorites, setFavorites] = useState<FavoriteMeal[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const {
    toast
  } = useToast();
  useEffect(() => {
    const fetchFavorites = async () => {
      try {
        const {
          data: {
            user
          }
        } = await supabase.auth.getUser();
        if (!user) {
          toast({
            title: "Authentication required",
            description: "Please sign in to view your favorites",
            variant: "destructive"
          });
          return;
        }
        const {
          data,
          error
        } = await supabase.from('favorites').select(`
            meals (
              id,
              name,
              price,
              image,
              rating,
              reviews_count,
              availability_slots,
              chef:profiles (
                first_name,
                last_name
              )
            )
          `).eq('user_id', user.id);
        if (error) throw error;
        setFavorites(data || []);
      } catch (error) {
        console.error('Error fetching favorites:', error);
        toast({
          title: "Error",
          description: "Failed to load favorites. Please try again.",
          variant: "destructive"
        });
      } finally {
        setIsLoading(false);
      }
    };
    fetchFavorites();
  }, [toast]);
  return <div className="min-h-screen bg-background pb-16">
      <header className="sticky top-0 z-50 bg-white border-b border-border">
        
      </header>
      <main className="container mx-auto px-4 py-6">
        
        {isLoading ? <ListLoadingState /> : favorites.length === 0 ? <p className="text-gray-500">You haven't added any favorites yet.</p> : <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {favorites.map(favorite => {
          const meal = favorite.meals;
          const chefName = meal.chef ? `${meal.chef.first_name} ${meal.chef.last_name}`.trim() : 'Anonymous Chef';
          return <MealCard key={meal.id} id={meal.id} name={meal.name} image={meal.image} rating={meal.rating} reviews={meal.reviews_count} distance="2.5 mi" price={meal.price} availabilitySlots={meal.availability_slots || []} chefName={chefName} className="h-full" />;
        })}
          </div>}
      </main>
    </div>;
};
export default Favorites;